import { useMutation, useQuery } from "@tanstack/react-query";
import { Buton } from "@koclukpanel/ui";
import type { PermissionCode } from "@koclukpanel/authz";
import type { DavetYenidenGonderIstegi } from "@koclukpanel/contracts";
import { benGetir, davetiYenidenGonder } from "./api";
import { izinKapsami, izinSorgusu } from "./izin";

// F-PPL-01b — dört giriş aynı sonucu gösterir; izin denetimi sunucuda yeniden yapılır.
export function DavetYenidenGonder({
  hedef,
  izin,
  izinli,
  tumKayitlarGerekli = false,
  onGonderildi,
}: {
  hedef: DavetYenidenGonderIstegi;
  izin?: PermissionCode;
  izinli?: boolean;
  tumKayitlarGerekli?: boolean;
  onGonderildi?: () => void;
}) {
  const ben = useQuery({ queryKey: ["ben"], queryFn: benGetir, enabled: izinli === undefined });
  const gonder = useMutation({
    mutationFn: () => davetiYenidenGonder(hedef),
    onSuccess: (sonuc) => {
      // F-PPL-01b — başarılı yeniden gönderimde eski hata uyarısı kalıp yeniden işlem istemesin.
      if (sonuc.davetGonderildi) onGonderildi?.();
    },
  });
  const gorunur =
    izinli ??
    (izin !== undefined &&
      ben.data !== undefined &&
      izinSorgusu(ben.data.izinler)(izin) &&
      (!tumKayitlarGerekli || izinKapsami(ben.data.izinler, izin) === "ALL"));
  if (!gorunur) return null;
  return (
    <div className="flex flex-col gap-2">
      <Buton gorunum="ikincil" disabled={gonder.isPending} onClick={() => gonder.mutate()}>
        Daveti yeniden gönder
      </Buton>
      {gonder.isSuccess && (
        <p role="status">
          {gonder.data.davetGonderildi
            ? "Davet gönderildi."
            : "Davet postası gönderilemedi. Daha sonra yeniden deneyin."}
        </p>
      )}
      {gonder.isError && <p role="alert">{gonder.error.message}</p>}
    </div>
  );
}
